import React from 'react';
import { Link } from 'react-router-dom';

const AdminNotFound = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <div className="max-w-md w-full text-center">
                <div className="mb-8">
                    <h1 className="text-9xl font-bold text-[#31415A]">404</h1>
                    <div className="w-24 h-1 bg-[#31415A] mx-auto mt-4 rounded-full"></div>
                </div>

                <h2 className="text-3xl font-bold text-gray-900 mb-4">Admin Page Not Found</h2>
                <p className="text-gray-600 mb-8">
                    The admin page you're looking for doesn't exist or has been moved.
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Link
                        to="/admin/dashboard"
                        className="px-6 py-3 bg-[#31415A] text-white rounded-lg hover:bg-[#2a3850] transition-colors font-medium inline-flex items-center justify-center gap-2"
                    >
                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                        </svg>
                        Go to Dashboard
                    </Link>
                    <button
                        onClick={() => window.history.back()}
                        className="px-6 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors font-medium"
                    >
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdminNotFound;
